export const TYPES = {
  bool: "bool",
  select: "select"
}

const RGB_CONF = [
  {
    label: "RGBW",
    value: 1
  },
  {
    label: "RGB-Warm White",
    value: 2
  },
  {
    label: "RGB",
    value: 3
  },
  {
    label: "GRB",
    value: 4
  },
  {
    label: "GRBW",
    value: 5
  },
  {
    label: "GRB-Warm White",
    value: 6
  }
]

export const additionalFeaturesConfig = {

    increased_switch_delay: {
      actualName: 'increased_switch_delay',
      displayName: 'Increase Switch Delay',
      inputType: TYPES.bool,
      featureDescription: 'Enable this if you have Inverters and Irregular Power Supplies. It might increase delay in any switch action, but helps in resolving the flickering issue.',
      value: false
    },
    virtual_switch_override: {
      actualName: 'virtual_switch_override',
      displayName: `Don't Use as 2 Way Switch`,
      inputType: TYPES.bool,
      featureDescription: 'Enable this feature if you do not wish to use the switch as the two-way switch. ( Ex. If you turn off your lights using the Mobile app, Google or Alexa and then if you toggle the switch state manually it would turn off the lights, irrespective of the state. )',
      value: false
    },
  
    disable_led_lights: {
      actualName: 'disable_led_lights',
      displayName: `Disable LED Light on device`,
      inputType: TYPES.bool,
      featureDescription: 'Enable this feature if you do not want to see any light on device.',
      value: false
    },
  
    use_dimmer_1: {
      actualName: 'dimmer_disable',
      displayName: 'Disable dimmer',
      inputType: TYPES.bool,
      featureDescription: 'Use this feature if you want to use the dimmer channel in the device as regular switch',
      value: 1
    },
  
    dbm: {
      actualName: 'dbm',
      displayName: 'Disable Door Bell',
      inputType: TYPES.bool,
      featureDescription: 'Enabling this option will silent your physical doorbell, you will get notification in mobile app',
      value: 2
    },
  
    rgb_conf: {
      actualName: 'rgb_conf',
      displayName: 'LED Color Type',
      inputType: TYPES.select,
      featureDescription: 'Select the color scheme of the LED lights Eg. RGB, GRB, RGBW etc',
      value: 1,
      options: RGB_CONF
    }
  };
  


// WEBPACK FOOTER //
// ./components/rooms/AdditionalSettings.js